import API from "../../../API/API";

export const ADD_POST_VIEW_INITIATE = "ADD_POST_VIEW_INITIATE";
export const ADD_POST_VIEW_SUCCESS = "ADD_POST_VIEW_SUCCESS";
export const ADD_POST_VIEW_FAILURE = "ADD_POST_VIEW_FAILURE";

export const addPostViewInitiate = (data) => async (dispatch) => {
    dispatch({ type: ADD_POST_VIEW_INITIATE });

    try {
        const api = new API();
        const response = await api.post("view", data);

        dispatch({
            type: ADD_POST_VIEW_SUCCESS,
            payload: response.data,
        });

        return response;
    } catch (error) {
        dispatch({
            type: ADD_POST_VIEW_FAILURE,
            payload: error.response?.data?.message || "Failed to record view",
        });

        throw error;
    }
};
